import React, { useState } from 'react';
import {
  Alert, Card, CardContent, Snackbar, Stack, Tab, Tabs,
} from '@mui/material';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import ApprovalContent from '../components/ApprovalContent';
import PageHeader from '../components/PageHeader';
import StateBoundary from '../components/StateBoundary';
import { useSession } from '../viewmodels/SessionViewModel';
import { useApprovalsViewModel } from '../viewmodels/ApprovalsViewModel';

const EMPTY_TEXT = {
  pending: 'Nothing needs your approval right now. When your team proposes something, it will appear here first.',
  all: 'No requests yet.',
};

export default function ApprovalsView() {
  const { isOwner } = useSession();
  const [filter, setFilter] = useState('pending');
  const vm = useApprovalsViewModel(filter);

  return (
    <>
      <PageHeader title="Approvals" subtitle="Nothing leaves your business, and no team member is added, until you approve it." />
      <Tabs value={filter} onChange={(_, v) => setFilter(v)} sx={{ mb: 2.5 }}>
        <Tab value="pending" label="Waiting for you" />
        <Tab value="all" label="All" />
      </Tabs>
      <StateBoundary
        loading={vm.loading}
        error={vm.error}
        onRetry={vm.reload}
        isEmpty={vm.approvals.length === 0}
        empty={{ icon: <FactCheckOutlinedIcon fontSize="large" />, title: 'No requests', body: EMPTY_TEXT[filter] }}
      >
        <Stack spacing={2}>
          {vm.approvals.map((a) => (
            <Card key={a.id}>
              <CardContent>
                <ApprovalContent
                  approval={a}
                  isOwner={isOwner}
                  busy={vm.busyId === a.id}
                  onApprove={(grants) => vm.approve(a.id, grants)}
                  onReject={() => vm.reject(a.id)}
                />
              </CardContent>
            </Card>
          ))}
        </Stack>
      </StateBoundary>
      <Snackbar open={Boolean(vm.feedback)} autoHideDuration={6000} onClose={vm.clearFeedback} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        {vm.feedback ? <Alert severity={vm.feedback.severity} onClose={vm.clearFeedback}>{vm.feedback.text}</Alert> : undefined}
      </Snackbar>
    </>
  );
}
